export const leadership = [
  {
    id: 1,
    name: "Ganshyam Patel",
    role: "Founder & CEO",
    image: "/assets/Ganshyamsir.jpeg",
    vision: "At Dhyon Technologies, we believe in the transformative power of the cloud. Our mission is to empower businesses to scale without limits, innovate without fear, and succeed in a digital-first world.",
    bio: "Driving the company's strategic vision with a focus on innovation and customer success."
  },
  {
    id: 2,
    name: "Seema Singh Patel",
    role: "Co-Founder",
    image: "/assets/SeemaMa'am.jpeg",
    vision: "Building a culture of excellence and integrity is at the heart of everything we do. We are not just building software; we are building lasting partnerships and a legacy of trust.",
    bio: "Fostering a people-first culture and ensuring operational excellence across all levels."
  }
];

export const teamMembers = [
  {
    id: 0,
    name: "Subodh Kumar",
    role: "Senior Functional Consultant",
    image: "/assets/subodhsir.jpeg",
    objectPosition: "object-top"
  },
  {
    id: 1,
    name: "Dimple Patel",
    role: "HR Head",
    image: "/assets/Dimple.jpeg",
    objectPosition: "object-center"
  },
  {
    id: 2,
    name: "Sujal Mali",
    role: "Cloud Tech Head",
    image: "/assets/sujal.jpeg"
  },
  {
    id: 3,
    name: "Viral Bhavani",
    role: "Sales Head",
    image: "/assets/viral.jpeg"
  },
  {
    id: 4,
    name: "Paras Patel",
    role: "AI Development Head",
    image: "/assets/parasbhai.jpeg"
  },
  {
    id: 5,
    name: "Uday Ramani",
    role: "Software Development Head",
    image: "/assets/udaybhai.jpeg"
  }
];
